import { gql } from "@apollo/client";

export const GET_ALL_USERGROUPS = gql`
  query userGroupTypes {
    userGroupTypes {
      UserGroupTypeId
      Name
      MembersMin
      MembersMax
      Created
      Updated
    }
  }
`;
